import { MaxWidth } from "shared/components/MaxWidth";
import { RichText } from "shared/components/RichText";
import { SMALL } from "shared/utils/constants";
import styles from "./Message.module.css";

export const MessageContainer = ({ title, body, size = SMALL }) => (
  <div className="MessageContainer">
    <MaxWidth size={size}>
      <Message title={title} body={body} />
    </MaxWidth>
  </div>
);

export const Message = ({ title, body }) => (
  <div className={styles.message}>
    <RichText>
      <h2>{title}</h2>
      <p>{body}</p>
    </RichText>
  </div>
);
